// extracted by mini-css-extract-plugin
export default {"modalOverlay":"uN-z","modalContent":"vN-z","header":"wN-z","close":"xN-z"};